import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { galleryIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';

import { PageType } from '../../../../types/__generated__';
import clientConfig from '../../../client/config';
import { PageMetaContext } from '../../../context/PageMetaContext';
import { useNotNullableContext } from '../../../hooks/useNotNullableContext';
import { usePageOwner } from '../../../hooks/usePageOwner';
import Button from '../../Button/Button';

import styles from './ImageButtons.scss';
import { usePageMeta } from '../../../hooks';

interface ImageButtonsProps {
  onViewGallery: () => void;
}

const ImageButtons: FunctionComponent<ImageButtonsProps> = ({
  onViewGallery,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { isPageOwner } = usePageOwner();
  const { isPreview } = usePageMeta();
  const { pageShortName, pageSlug, pageType } = useNotNullableContext(
    PageMetaContext,
  );

  const changeCoverUrl =
    pageType === PageType.OnePage.toLowerCase()
      ? `${clientConfig.baseUri}/${pageSlug}/admin`
      : `${clientConfig.baseUri}/fundraising-edit/${pageShortName}/media`;

  return (
    <div className={styles.wrapper} data-qa="image-buttons">
      {isPageOwner ? (
        <>
          <Button
            className={styles.button}
            onClick={onViewGallery}
            aria-label={t('common.openGallery', 'Open the Image Gallery')}
          >
            {t('common.viewGallery', 'View gallery')}
          </Button>
          {!isPreview && (
            <a href={changeCoverUrl}>
              <Button className={styles.button}>
                {t('common.changeCover', 'Change cover')}
              </Button>
            </a>
          )}
        </>
      ) : (
        <Button
          className={styles.button}
          onClick={onViewGallery}
          aria-label={t('common.openGallery', 'Open the Image Gallery')}
        >
          <Svg markup={galleryIcon} className={styles.icon} />
        </Button>
      )}
    </div>
  );
};

export default ImageButtons;
